import { useEffect, useRef, useState } from "react";
import { thumb, thumbSet } from "@/lib/api";

// Blur-up image: a ~1KB blurred preview shows instantly, then the real tile image fades in sharp over it.
export const BlurImg = ({ src, w = 900, sizes, alt, className = "", imgClassName = "", testid, position }) => {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(!!ref.current?.complete && ref.current.naturalWidth > 0);
  }, [src]);

  const tiny = thumb(src, 32);
  const style = position ? { objectPosition: position } : undefined;
  return (
    <span className={`absolute inset-0 overflow-hidden bg-[#12131A] ${className}`}>
      {tiny !== thumb(src, w) && (
        <img src={tiny} alt="" aria-hidden="true" style={style} className={`absolute inset-0 w-full h-full object-cover scale-110 blur-xl transition-opacity duration-700 ${loaded ? "opacity-0" : "opacity-100"}`} />
      )}
      <img ref={ref} src={thumb(src, w)} srcSet={sizes ? thumbSet(src) : undefined} sizes={sizes} alt={alt} loading="lazy" data-testid={testid} style={style}
        data-loaded={loaded ? "true" : "false"} onLoad={() => setLoaded(true)} onError={() => setLoaded(true)}
        className={`absolute inset-0 w-full h-full object-cover transition-[opacity,filter,transform] duration-700 ease-out ${loaded ? "opacity-100 blur-0" : "opacity-0 blur-md"} ${imgClassName}`} />
    </span>
  );
};
